<div class="container-fluid" style="position: relative; height: 100vh; padding-left: 3rem;">
  <div class="d-flex mt-4" style="align-items: center; margin-bottom: 10px;">
<!--    <img src="assets/img/ic_change.png" alt="" style="width: 60px; height: 60px" class="rounded-circle shadow-5" />-->
    <h1 class="dashboard-heading" style="margin-left: 10px;">Generate Institution API Access Keys</h1>
  </div>
  <hr />

  <div class="d-flex justify-content-center mt-5 mb-5">
    <div class="change-password-layout container-fluid form-content shadow-5 col-md-5">
      <div class="row justify-content-center form">
<!--        <h2 class="login-form-title">Generate Institution API Access Keys</h2>-->

        <form class="text-center row g-3" [formGroup]="form" (ngSubmit)="onClickSubmit()" novalidate>
          <div class="col-md-12 text-start">
            <label for="appName" class="form-label">App Name</label>
            <input type="text" class="form-control" id="appName" formControlName="appName"
              [ngClass]="{ 'is-invalid': submitted && formControl['appName'].errors }" />
            <div *ngIf="submitted && formControl['appName'].errors" class="invalid-feedback">
              <div *ngIf="formControl['appName'].errors['required']">App Name is required</div>
              <div *ngIf="formControl['appName'].errors['pattern']">Only letters, numbers, underscores and spaces
                allowed</div>
            </div>
            <label for="narration" class="form-label">Narration</label>
            <input type="text" class="form-control" id="narration" formControlName="narration"
              [ngClass]="{ 'is-invalid': submitted && formControl['narration'].errors }" />
            <div *ngIf="submitted && formControl['narration'].errors" class="invalid-feedback">
              <div *ngIf="formControl['narration'].errors['required']">Narration is required</div>
              <div *ngIf="formControl['narration'].errors['pattern']">Only letters, numbers, underscores and spaces
                allowed</div>
            </div>

            <label for="instCode" class="form-label">Institution Code</label>
            <input type="text" class="form-control" id="instCode" formControlName="instCode"
              [ngClass]="{ 'is-invalid': submitted && formControl['instCode'].errors }" />
            <div *ngIf="submitted && formControl['instCode'].errors" class="invalid-feedback">
              <div *ngIf="formControl['instCode'].errors['required']">Institution Code is required</div>
            </div>
            <label for="environment" class="form-label">Environment</label>
            <select class="form-select" id="environment" formControlName="environment"
              [ngClass]="{ 'is-invalid': submitted && formControl['environment'].errors }">
              <option value="" disabled selected>Select Environment</option>
              <option *ngFor="let env of environments" [value]="env">{{ env.toUpperCase() }}</option>
            </select>
            <div *ngIf="submitted && formControl['environment'].errors" class="invalid-feedback">
              <div *ngIf="formControl['environment'].errors['required']">Environment is required</div>
            </div>

            <ng-container
              *ngIf="!['dev', 'qa', 'sandbox'].includes(formControl['environment'].value?.trim()?.toLowerCase())">
              <label for="region" class="form-label">Region</label>
              <select class="form-select" id="region" formControlName="region"
                [disabled]="formControl['region'].disabled"
                [ngClass]="{ 'is-invalid': submitted && formControl['region'].errors }">
                <option value="" disabled selected>Select Region</option>
                <option *ngFor="let reg of regions" [value]="reg">{{ reg.toUpperCase() }}</option>
              </select>
              <div *ngIf="submitted && formControl['region'].errors" class="invalid-feedback">
                <div *ngIf="formControl['region'].errors['required']">Region is required</div>
              </div>
            </ng-container>
          </div>

          <div class="d-flex flex-row-reverse align-items-center">
            <div class="p-2 mt-2">
              <button *ngIf="!generateDisabled" type="submit" class="btn btn-primary">
                <div *ngIf="loading" class="spinner-border spinner-border-sm text-light" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <span *ngIf="!loading">Generate</span>
              </button>
            </div>
          </div>
        </form>
        <div *ngIf="preSignedUrl" class="mt-4">
          <div class="mt-3">
            <p>
<!--              <a [href]="preSignedUrl" target="_blank" class="btn btn-link p-0">-->
<!--                Generated Link-->
<!--              </a>-->
            </p>
            <button class="btn btn-primary mt-3" (click)="openInOutlook()">
              Open Draft in Outlook
            </button>
          </div>
        </div>

        <div *ngIf="error" class="alert alert-danger mt-3">
          {{ error }}
        </div>
      </div>
    </div>
  </div>
</div>
